// extracted by mini-css-extract-plugin
module.exports = {"base":"styles-m__base__fJym7","image-wrapper":"styles-m__image-wrapper__1Iyd5","text-wrapper":"styles-m__text-wrapper__3VADi","headline":"styles-m__headline__SfT8d"};